import React, { useCallback } from 'react';

import styles from './AddSuperBatchesToggleChips.module.scss';
import ToggleChip from 'components/ToggleChip';

export default function AddSuperBatchesToggleChips({
  selectedSuperBatches,
  setSelectedSuperBatches,
}) {
  const selectedSuperBatchesCount = selectedSuperBatches.length;

  const handleRemoveSuperBatches = useCallback(
    (superBatchId) => {
      setSelectedSuperBatches((prevSelectedSuperBatches) =>
        prevSelectedSuperBatches.filter((sb) => sb.id !== superBatchId)
      );
    },
    [setSelectedSuperBatches]
  );

  if (selectedSuperBatchesCount > 0) {
    return (
      <>
        <div className={styles.selectedSuperBatches}>
          {`Selected Batches (${selectedSuperBatchesCount})`}
        </div>
        <div className={styles.toggleChips}>
          {selectedSuperBatches.map((sb) => (
            <ToggleChip
              key={sb.id}
              isAdded
              className={styles.addToggleChip}
              onRemove={() => handleRemoveSuperBatches(sb.id)}
              label={sb.name}
            />
          ))}
        </div>
        <div className={styles.text}>
          The above selected batches will be added.
        </div>
      </>
    );
  }
  return null;
}
